export const amendmentsTags = ['Amendments'] as const;
